import { createFileRoute } from '@tanstack/react-router';

import { ReportPage } from '@/pages/inspection/report/ReportPage';
import { useLingui } from '@lingui/react/macro';
import { useSetTitle } from '@/stores/title-context';

// The same screen the member works in. It reads the viewed tenant the scope route provides, and its
// write affordances hang off the member-scoped permission set, which for a parent is read-only.
function MemberInspectionReportRoute() {
	const { t } = useLingui();
	useSetTitle(t`Member Inspection`);
	const { inspectionId } = Route.useParams();
	return <ReportPage inspectionId={inspectionId} />;
}

export const Route = createFileRoute('/_authenticated/_app/chain/companies/$memberId/inspections/$inspectionId/')({
	component: MemberInspectionReportRoute,
});
